export function isInApp() {
    return (window && window.location && window.location.pathname && window.location.pathname.indexOf("appchat") != -1);
}
